export default "__VITE_ASSET__504ee28b__"